import BaseAPI from "./base/base-api";

class ReportListAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = "Business";
  controllerName = "ReportList";

  /**
   * Lấy danh sách báo cáo
   */
  load() {
    let request = {
      url: this.getAPIUrl(),
    };

    return this.getAsync(request);
  }

  /**
   * Lấy báo cáo
   */
  getApply(reportId, reportListId) {
    let url = [this.getAPIUrl(), reportId];
    if (reportListId) {
      url.push(reportListId);
    }
    let request = {
      url: url.join("/"),
    };

    return this.getAsync(request);
  }

  getAllTemplateByReportID(reportId) {
    let url = [this.getAPIUrl(), "templates-by-report-id", reportId];
    let request = {
      url: url.join("/"),
    };

    return this.getAsync(request);
  }
}

export default new ReportListAPI();
